if (!customElements.get("product-request-information")) {
  customElements.define(
    "product-request-information",
    class ProductRequestInformation extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.collapsed = this.getAttribute("expanded") === "false";
        this.toggleElement = this.querySelector(".product-request-information-toggle");
        this.onToggle = this.onToggle.bind(this);
        this.toggleElement.addEventListener("click", this.onToggle);

        const query = new URLSearchParams(window.location.search);
        const isFitmentSubmission =
          query.get("contact_posted") === "fitment" &&
          (this.closest("form")?.matches(":target") || this.getAttribute("submitted") === "true");

        if (isFitmentSubmission) {
          this.showSubmissionConfirmation();
        } else if (this.closest("form")?.matches(":target")) {
          this.expand(false);
        }
      }

      onToggle(event) {
        event.preventDefault();
        this.handleToggle();
      }

      collapse() {
        this.setAttribute("expanded", "false");
        this.toggleElement.setAttribute("aria-expanded", "false");
        this.collapsed = true;
      }

      expand(shouldFocus = true) {
        this.setAttribute("expanded", "true");
        this.toggleElement.setAttribute("aria-expanded", "true");
        this.collapsed = false;
        if (shouldFocus) {
          this.querySelector('input[name="contact[name]"]')?.focus();
        }
      }

      showSubmissionConfirmation() {
        this.expand(false);
        this.setAttribute("submission-confirmed", "true");

        const confirmation = this.querySelector(".terrawagen-scoped-form-success");
        const heading = this.querySelector(".product-request-information-heading");
        if (heading) heading.textContent = "Fitment request sent ✓";
        confirmation?.removeAttribute("hidden");

        requestAnimationFrame(() => {
          confirmation?.focus({ preventScroll: true });
          confirmation?.scrollIntoView({ block: "center", behavior: "auto" });
        });
      }

      handleToggle() {
        if (this.collapsed) {
          this.expand();
        } else {
          this.collapse();
        }
      }
    },
  );
}
